// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_jl-5";
export var filledCircle = "_jl-4";
export var historyEntry = "_jl-3";
export var messageSideLeft = "_jl-1";
export var messageSideRight = "_jl-2";
export var orderTrackingInfoContainer = "_jl-0";